const hp = [
  {
    path: '/EquipMent',
    name: 'EquipMent',
    component: () => import("../views/Equipment/index.vue")
  },
  {
    path: "/company_registration",
    name: 'CompanyRegistration',
    component: () => import("../views/ComRegistration/index.vue"),
    meta:{title:"公司注册"}
  },
  {
    path: "/IndustrialDemand/:data?",
    name: 'IndustrialDemand',
    component: () => import("../views/IndustrialDemand/index.vue"),
    meta:{title:"产能地图-产业需求"}
  },
  {
    path: "/supplychain/:data?",
    name: 'supplychain',
    component: () => import("../views/supplychain/index.vue"),
    meta:{title:"供应链+"}
  },
  {
    path: "/application/:data?",
    name: 'application',
    component: () => import("../views/application/index.vue"),
    meta:{title:"供应链+"}
  },
  {
    path: "/industrialLibrary",
    name: 'industrialLibrary',
    component: () => import("../views/IndustrialLibrary/index.vue"),
    meta:{title:"产能地图-产业资源库"}
  },
  {
    path: "/nclink/:data?",
    name: 'nclink',
    component: () => import("../views/nclink/index.vue")
  },
  {
    path: "/ordinaryUsers",
    name: "ordinaryUsers",
    redirect: 'userCenter',
    component: () => import("../views/OrdinaryUsers/index.vue"),
    children: [
      {
        path: "/userCenter",
        name: "userCenter",
        component: () => import("../views/OrdinaryUsers/UserCenter/index.vue"),
        meta:{title:"个人中心"}
      },
      {
        path: "/companyUserList",
        name: "companyUserList",
        component: () => import("../views/OrdinaryUsers/Company/CompanyUserList/index.vue"),
        meta:{title:"用户列表"}
      },
      {
        path: "/capaList",
        name: "capaList",
        component: () => import("../views/OrdinaryUsers/CapaList/index.vue"),
        meta:{title:"产能列表"}
      },
      {
        path: "/supply",
        name: "supply",
        component: () => import("../views/OrdinaryUsers/supply/index.vue"),
        meta:{title:"供需列表"}
      },
      {
        path: "/add/:data?",
        name: "addProduct",
        component: () => import("../views/OrdinaryUsers/AddProduct/index.vue"),
        meta:{title:"添加"}
      },
      {
        path: "/edit",
        name: "editProduct",
        component: () => import("../views/OrdinaryUsers/EditProduct/index.vue"),
        meta:{title:"修改"}
      }
    ]
  },
  {
    path: "/userRegister/:companyName/:timeOut/:token",
    name: "userRegister",
    component: () => import("../views/OrdinaryUsers/UserRegistration/index.vue"),
    meta:{title:"用户注册"}
  },
  {
    path: "/success",
    name: 'success',
    component: () => import("../views/OrdinaryUsers/UserRegistration/success.vue")
  }
]
export default hp;